import commonActionTypes from './action-types';

export const setContext = payload => ({
  type: commonActionTypes.SET_CONTEXT,
  payload,
});

export const fetchDropdowns = payload => ({
  type: commonActionTypes.FETCH_DROPDOWNS,
  payload,
});

export const fetchDropdownsSuccess = payload => ({
  type: commonActionTypes.FETCH_DROPDOWNS_SUCCESS,
  payload,
});

export const fetchDropdownsFail = payload => ({
  type: commonActionTypes.FETCH_DROPDOWNS_FAIL,
  payload,
});

export const fetchFirebaseConfig = payload => ({
  type: commonActionTypes.FETCH_FIREBASE_CONFIG,
  payload,
});

export const fetchFirebaseConfigSuccess = payload => ({
  type: commonActionTypes.FETCH_FIREBASE_CONFIG_SUCCESS,
  payload,
});

export const fetchFirebaseConfigFail = payload => ({
  type: commonActionTypes.FETCH_FIREBASE_CONFIG_FAIL,
  payload,
});
